import { MouseEventHandler } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  Popover,
} from '@mui/material'

import useStyles from './styles'
import { ETranslationNs } from 'src/types'

interface IProps {
  open: boolean
  anchorRef: React.RefObject<HTMLElement>
  handleClose: MouseEventHandler<HTMLButtonElement>
  handleImagesOpen: MouseEventHandler<HTMLDivElement>
}

export const StubInputPopover = ({ anchorRef, open, handleClose, handleImagesOpen }: IProps) => {
  const [t] = useTranslation(ETranslationNs.Form)
  const classes = useStyles({})

  return (
    <Popover
      open={open}
      anchorEl={anchorRef.current}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Paper>
        <List disablePadding sx={{ padding: 0 }}>
          <ListItem disablePadding>
            <ListItemButton onClick={handleImagesOpen}>
              <ListItemText
                primaryTypographyProps={{ className: classes.popOverPrimary }}
                primary={t('suggest-button-text.v')}
              />
            </ListItemButton>
          </ListItem>
          <Divider />
        </List>
      </Paper>
    </Popover>
  )
}
